/**
 * 'test sting' => 'Test string'
 */
const capitalize = (value: string) => `${value[0].toUpperCase()}${value.slice(1)}`;

export { capitalize };
